"use strict";
const { cx } = require("lib/utils");
const Badge = ({ count, modifier }) => {
  if (!count) return null;

  return <span className={cx("SidebarNav-badge", modifier)}>{count}</span>;
};

module.exports = Badge;
